exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ele-import-finish{text-align:center}.ele-import-finish .el-icon-success{font-size:150px;line-height:1.2;color:#67c23a}", ""]);

// exports
